import { render, staticRenderFns } from "./ReviewEOI.vue?vue&type=template&id=24e9c5d8&scoped=true&"
import script from "./ReviewEOI.vue?vue&type=script&lang=js&"
export * from "./ReviewEOI.vue?vue&type=script&lang=js&"
import style0 from "./ReviewEOI.vue?vue&type=style&index=0&id=24e9c5d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e9c5d8",
  null
  
)

export default component.exports